import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { ReportContext } from "../AppLayout";
import { Loading } from "@creditsafe/ui-components";

interface ServiceLineCheckWrapperProps {
  isUpp: boolean | undefined;
  children: React.ReactNode;
}

const ServiceLineCheckWrapper: React.FC<ServiceLineCheckWrapperProps> = ({
  children,
  isUpp,
}) => {
  const { uppUseHistoryObject } = useContext(ReportContext);

  const kycServiceLinesState = useSelector(
    (state: RootState) => state.user.services
  );

  const isServiceLinesLoaded = useSelector(
    (state: RootState) => state.user.isServiceLinesLoaded
  );

  const { pathname } = useLocation();

  useEffect(() => {
    if (isServiceLinesLoaded) {
      kycServiceLinesState.map((serviceLine) => {
        if (
          pathname.startsWith(serviceLine.path) &&
          serviceLine.isServiceStateActive === false &&
          serviceLine.isServiceLineLoaded === false &&
          isUpp
        ) {
          return uppUseHistoryObject.push(
            `/notInSubscription?code=${serviceLine.serviceId}`
          );
        }
      });
    }
  }, [kycServiceLinesState, isServiceLinesLoaded]);

  return isServiceLinesLoaded ? (
    children
  ) : (
    <Loading
      className=""
      text="Loading"
      dotsCount={5}
      fadeInPercentage={66}
      delayMilliseconds={500}
    />
  );
};

export default ServiceLineCheckWrapper;
